// extracted by mini-css-extract-plugin
module.exports = {"tickerChartLegend":"styles_tickerChartLegend__drs5p"};